export default {
  props: {
    text: {
      type: String,
      default: '打开APP，查看更多内容'
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {
    styles: function styles() {
      if (this.isApple || !this.isApp) {
        return {};
      }
      var statusBarHeight = window.cfmoto.statusBarHeight();
      return {
        paddingBottom: "".concat(statusBarHeight, "px")
      };
    }
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};